import { ReactNode } from "react";
import { Link } from "react-router-dom";
// // GS-4 Start

type Props = {
  id?: number;
  children: ReactNode;
  path?: string;
};

export default function RedirectProfile({
  id,
  children,
  path = "/admin/employees",
}: Props) {
  return (
    <Link className="hover:text-inherit" to={id ? `${path}/view/${id}` : ""}>
      {children}
    </Link>
  );
}
